(function () {
  const easternClock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
  });
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC'
  });

  function easternTime(date) {
    const parts = {};
    easternClock.formatToParts(date).forEach(part => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second));
  }

  function estimate(now) {
    const eastern = easternTime(now);
    const cutoff = new Date(eastern);
    cutoff.setUTCHours(11, 0, 0, 0);
    if (eastern >= cutoff) cutoff.setUTCDate(cutoff.getUTCDate() + 1);
    while (cutoff.getUTCDay() === 0 || cutoff.getUTCDay() === 6) {
      cutoff.setUTCDate(cutoff.getUTCDate() + 1);
    }

    // Convert the Eastern cutoff to an instant, including weekend DST changes.
    const offset = easternTime(cutoff).getTime() - cutoff.getTime();
    const minutes = Math.max(0, Math.floor((cutoff.getTime() - offset - now.getTime()) / 60000));
    const delivery = new Date(cutoff);
    delivery.setUTCDate(delivery.getUTCDate() + 3);
    return {
      date: dateFormatter.format(delivery),
      isoDate: delivery.toISOString().slice(0, 10),
      countdown: Math.floor(minutes / 60) + 'hrs ' + minutes % 60 + 'min'
    };
  }

  class ProductDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.date = this.querySelector('[data-delivery-date]');
      this.countdown = this.querySelector('[data-delivery-countdown]');
      if (!this.date || !this.countdown) return;
      this.refresh = () => {
        if (document.hidden) return;
        const delivery = estimate(new Date());
        if (this.date.textContent !== delivery.date) {
          this.date.textContent = delivery.date;
          this.date.setAttribute('datetime', delivery.isoDate);
        }
        if (this.countdown.textContent !== delivery.countdown) this.countdown.textContent = delivery.countdown;
        this.countdown.parentElement.hidden = false;
        this.date.parentElement.hidden = false;
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  }

  if (!customElements.get('product-delivery-estimate')) {
    customElements.define('product-delivery-estimate', ProductDeliveryEstimate);
  }
})();
